import React from 'react';
import { t } from 'ttag';

import { Links } from '@modules';

import { useSiteSettings } from '../context/SiteSettingsContext';

export default function SocialLinks() {
  const { currentSiteSettings } = useSiteSettings();

  const currentDomain = window.location.hostname;

  const siteData =
    currentSiteSettings && currentSiteSettings.length
      ? currentSiteSettings.find(site => site.site?.domain === currentDomain)
      : null;

  const socialLinks = siteData?.social_links || {};

  return (
    <section className="space-y-8 px-3 py-16 lg:py-20">
      <h2 className="m-0 text-left text-sm font-semibold uppercase text-gray before:mb-4 before:h-[1px] before:bg-gray/80 before:content-['']">{t`follow us here`}</h2>
      <div className="p-0">
        <Links>
          {Object.entries(socialLinks)?.map(([platform, url]) => (
            <Links.Link
              className="leading-1 justify-between border-none py-2 text-4xl font-extrabold leading-none tracking-tight text-white no-underline md:text-6xl lg:justify-normal lg:text-8xl"
              href={url}
              key={platform}
            >
              {platform}
              <Links.Link.Icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z" />
                </svg>
              </Links.Link.Icon>
            </Links.Link>
          ))}
        </Links>
      </div>
    </section>
  );
}
